<template>
  <v-dialog ref="dialog" v-model="dialog" max-width="600px"  :fullscreen="screenWidth<600" transition="scale-transition">
    <v-card style="overflow:hidden;">
      <div :style="{backgroundColor: this.styles.general.theme_color_light}">
        <v-layout>
          <v-btn icon dark v-on:click="closeViewEvent">
            <v-icon >close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout class="pb-4 mx-2 px-2">
          <v-flex xs2  class="text-xs-center event_icon">
            <img :src="item.logo ? item.logo: '/static/images/event-icon.png'"/>
          </v-flex>
          <v-flex xs10 class="mx-4 event_title">
            <span  >{{ item.title }}</span>
          </v-flex>
        </v-layout>
      </div>

      <v-layout justify-end >
        <v-flex xs4 sm4 md2 class="event_share">
          <a :href="item.link" target="_blank" style="text-decoration: none;">
          <v-btn flat medium  :style="{color: styles.general.theme_color_dark}">
            <v-layout column style="text-transform:capitalize;">
              <v-icon medium>date_range</v-icon>
              RSVP
            </v-layout>
          </v-btn></a>
        </v-flex>

        <v-flex xs4 sm4 md2 class="event_share">
          <v-btn v-if="!favorited" flat medium :style="{color: styles.general.theme_color_dark}" @click.prevent="favoriteItem">
            <v-layout column>
              <v-icon medium>favorite</v-icon>
              Favorite
            </v-layout>
          </v-btn>
          <v-btn v-else flat medium :style="{color: styles.general.theme_color_dark}" @click.prevent="unfavoriteItem">
            <v-layout column>
              <v-icon medium color="red">favorite</v-icon>
              Favorite
            </v-layout>
          </v-btn>
        </v-flex>

        <v-flex xs4 sm4 md2 class="event_share">
          <share-button color="secondary" text="Share" size="28px" :link="link"></share-button>
        </v-flex>
      </v-layout>

      <v-layout column class="mx-3" :style="resize">
        <v-flex xs12 class="my-2">
          <span class="bold">Description</span>
          <p>{{ item.description || '-'}}</p>
        </v-flex>

        <v-flex xs12 class="my-2">
          <v-icon>query_builder</v-icon>
          <span>{{ item.eventdate | actualDate }} at {{ item.starteventtime }} </span>
        </v-flex>

        <v-flex xs12 class="my-2">
          <v-icon>room</v-icon>
          <span>{{ item.location || '-' }}</span>
        </v-flex>

        <v-flex xs12 class="my-2">
          <v-icon>date_range</v-icon>
          <span>{{ item.user.firstname + ' ' + item.user.lastname}} - {{ item.user.jobtitle || '-'}}</span>
        </v-flex>
        <v-flex xs12 class="my-2 event_link">
          <v-icon>link</v-icon>
          <a :href="item.link" target="_blank">{{item.link}}</a>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import ShareButton from '@/components/ShareButton.vue'
export default {
  components: {
    ShareButton
  },
  props: ["item", "trigger"],
  mounted () {
    this.getFavourited
    const self = this
    window.addEventListener('resize', () => {
      const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      if (height <= 452) {
        self.resize = {
          overflowY: 'scroll',
          marginBottom: '15px',
          height: '195px'
        }
        return
      }
      if (height < 670 ) {
        self.resize = {
          overflowY: 'scroll',
          marginBottom: '15px',
          height: '216px'
        }
        return
      }
      self.resize = {}
    }, false)
  },
  data () {
      return {
          favorited:false,
          seen:false,
          resize: {}
      }
    },
  methods: {
      copyToClipboard (link) {
          var self = this
          this.$copyText(link).then(function (e) {
              let snackbar = {
                  active: true,
                  text: 'Link Successfully Copied To Clipboard'
              }
              self.$store.dispatch('triggerSnackbar', snackbar)

              setTimeout(() => {
                  let snackbar = {
                      active: false,
                      text: ''
                  }
                  self.$store.dispatch('triggerSnackbar', snackbar)
              }, 2000)


          }, function (e) {
              let snackbar = {
                  active: true,
                  text: 'Unable To Copy Link To Clipboard'
              }
              self.$store.dispatch('triggerSnackbar', snackbar)
          })
      },
    closeViewEvent() {
      this.$emit("closeModal")
    },
    favoriteItem () {
        let favoritePayload = {
          [this.item.uid]: this.item.uid
        }
        let self = this
        self.favorited = true
        this.$firebase.database().ref(`favorites/events/${this.userDetails.uid}/${this.item.eventKey}`).set(favoritePayload)
      },
      unfavoriteItem () {
          let self = this
        self.favorited = false
        this.$firebase.database().ref(`favorites/events/${this.userDetails.uid}/${this.item.eventKey}`).set(null)
      },
      getFavourited () {
        var self = this
        this.$firebase.database()
        .ref(`favorites/events/${this.userDetails.uid}/${this.item.eventKey}`)
        .on('value', function(snapshot) {
            if (!snapshot.val()) {
                self.favorited = false
            } else {
                self.favorited = true
            }
        })
    },
  },
  computed: {
    userDetails () {
      return this.$store.getters.getUserDetails
    },
    screenWidth() {
      return this.$vuetify.breakpoint.width
    },
    dialog: {
      get () {
        if (this.trigger) {
          this.favorited = false
          this.getFavourited()
        }
        return this.trigger
      },
      set (val) {
        this.$emit("closeModal")
      }
    },
    styles() {
      return this.$store.getters.getStyles;
    },
    link () {
      var link = `https://${window.location.host}/events#id=${this.item.eventKey}`
      return link
    }
  },
};
</script>

<style>
  .event_icon img{
    width:50px;
  }
  .event_title span{
    font-size: 20px;
    color: white;
    line-height: 22px;
  }
  .event_share{
    float:left;
    margin:10px 0;
  }
  .event_share .btn{
    height:auto;
  }
  .event_link a{
    color:#000;
    text-decoration: none;
  }
   .event_link a:hover{
     text-decoration: underline;
   }
  .share_list{
    position: absolute;
    top: 0;
  }
  .share_list a{
    height:auto;
    font-size: 12px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// EventViewModal.vue?5ab877a8